import { IconButton, Typography } from '@mui/material';

import { IconCloseMS } from '../../../../../../constants/icons';
import { CommentComposer } from './CommentComposer';
import { CommentList } from './CommentList';
import { DrawerHeader, SectionTitle, StyledDrawer } from './styles';
import {
  useCompanyComments,
  useCompanyCommentsHistory,
} from './useCompanyComments';

interface CommentsDrawerProps {
  open: boolean;
  onClose: () => void;
  noticeId: number;
  licensedCompanyId: number | undefined;
  companyName: string;
}

export function CommentsDrawer({
  open,
  onClose,
  noticeId,
  licensedCompanyId,
  companyName,
}: CommentsDrawerProps): JSX.Element {
  // `open` como gate: nada é buscado antes de abrir.
  const { comments, loading, submitting, submitComment } = useCompanyComments({
    noticeId,
    licensedCompanyId,
    enabled: open,
  });
  const { history, loading: historyLoading } = useCompanyCommentsHistory(
    licensedCompanyId,
    noticeId,
    open
  );

  return (
    <StyledDrawer anchor="right" open={open} onClose={onClose}>
      <DrawerHeader>
        <IconButton onClick={onClose} aria-label="fechar comentários">
          {IconCloseMS}
        </IconButton>
      </DrawerHeader>
      <Typography fontSize={21} fontWeight={600} color="common.grey">
        {companyName}
      </Typography>

      <SectionTitle>Comentários deste edital</SectionTitle>
      <CommentList
        comments={comments}
        loading={loading}
        emptyText="Nenhum comentário neste edital."
      />
      <CommentComposer submitting={submitting} onSubmit={submitComment} />

      <SectionTitle>Histórico de outros editais</SectionTitle>
      <CommentList
        comments={history}
        loading={historyLoading}
        emptyText="Nenhum comentário em editais anteriores."
        showNotice
      />
    </StyledDrawer>
  );
}
